import DateFormat from "sap/ui/core/format/DateFormat";
import Type from "./Type";
import UI5Date from "sap/ui/core/date/UI5Date";
import FormatException from "sap/ui/model/FormatException";
import ParseException from "sap/ui/model/ParseException";
import ValidateException from "sap/ui/model/ValidateException";

export type MCTimeFormatOptions = {
    pattern?: string; // Custom time format pattern
    strictParsing?: boolean; // Whether to use strict parsing
};
export default class MCTime extends Type {
    private formatOptions: MCTimeFormatOptions;

    private timeInstance;
    constructor(formatOptions?: MCTimeFormatOptions) {
        super();
        if (formatOptions) {
            this.formatOptions = {
                pattern: formatOptions.pattern || "Hm", // Default time format
                strictParsing: formatOptions.strictParsing !== undefined ? formatOptions.strictParsing : true, // Enable strict parsing by default
            };
        }
        else {
            this.formatOptions = {
                pattern: "Hm", // Default time format
                strictParsing: true, // Enable strict parsing by default
            };
        }
        this.timeInstance = DateFormat.getTimeInstance(this.formatOptions);
    }

    public formatValue(value: string | Date): string {
        if (!value) {
            return "";
        }
        if (typeof value === "string") {
            value = UI5Date.getInstance(value);
        } else if (!(value instanceof Date)) {
            throw new FormatException(`Invalid type for value: ${typeof value}. Expected string or Date.`) as Error;
        }
        try {
            return this.timeInstance.format(value);
        } catch {
            throw new FormatException(`Invalid time value: ${value instanceof Date ? value.toISOString() : value}`) as Error;
        }
    }


    public parseValue(value: string): Date {
        if (!value) {
            throw new ParseException("Value cannot be empty or undefined.") as Error;
        }
        const dateInstance = UI5Date.getInstance(value);
        if (!(dateInstance instanceof Date)) {
            throw new ParseException(`Invalid time string: ${value}.`) as Error;
        }
        return dateInstance;
    }

    public validateValue(value: string | Date): void {
        if (!value) {
            throw new ValidateException("Value cannot be empty or undefined.") as Error;
        }
        if (typeof value === "string") {
            value = UI5Date.getInstance(value);
        } else if (!(value instanceof Date)) {
            throw new ValidateException(`Invalid type for value: ${typeof value}. Expected string or Date.`) as Error;
        }
        if (isNaN(value.getTime())) {
            throw new ValidateException(`Invalid date object: ${value.toISOString()}`) as Error;
        }
    }

}

